import { render, staticRenderFns } from "./TabPosts.vue?vue&type=template&id=09380a08&scoped=true"
import script from "./TabPosts.vue?vue&type=script&lang=js"
export * from "./TabPosts.vue?vue&type=script&lang=js"
import style0 from "./TabPosts.vue?vue&type=style&index=0&id=09380a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09380a08",
  null
  
)

export default component.exports